import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import {
//   Link,
  LinkIcon
} from '../'
import Styles from './ExclusionsHoldingList.css'


@CSSModules(Styles, {allowMultiple:true})
class ExclusionsHoldingListRow extends Component {
  static propTypes = {
    idx: PropTypes.number,
    holding: PropTypes.object,
    issueId: PropTypes.string
  }

  constructor(props){
    super(props)

    let isHigh = false
    let isExtreme = false
    // high or extreme ?
    if (props.issueId === 'pff') {
      isHigh = (props.holding.is_pff_high)
      isExtreme = (props.holding.is_pff_extreme)
    } else if (props.issueId === 'wff') {
      isHigh = (props.holding.is_nw || props.holding.is_cm)
    }

    let highStyl = ''
    let triangleTitle = ''
    if (isExtreme) {
      highStyl = ' cell--extreme'
      triangleTitle = 'Private Prison Operator'
    } else if (isHigh) {
      highStyl += ' cell--high'
      triangleTitle = 'High Risk'
    }

    this.state = {
      isHigh,
      isExtreme,
      highStyl,
      triangleTitle,
    }
  }

  render() {
    const icnPp = require( '../../../static/images/sectoricons/icn-is_prisons.svg' )
    const icnBd = require( '../../../static/images/sectoricons/icn-is_borders.svg' )
    const icnNw = require( '../../../static/images/sectoricons/icn-is_nw.svg' )
    const icnCm = require( '../../../static/images/sectoricons/icn-is_cm.svg' )

    //
    return <div styleName='exclusions-holding'>
      <div styleName={'exclusions-holding__high-flag'+this.state.highStyl}>
        {
          this.state.isHigh || this.state.isExtreme ?
            <LinkIcon
              faclass='fa-exclamation-triangle'
              nospace
              title={this.state.triangleTitle}
              alt={this.state.triangleTitle}
            /> :
            null
        }
      </div>
      <div styleName={'exclusions-holding__idx'+this.state.highStyl}>
        { this.props.idx }.
      </div>
      <div styleName={'exclusions-holding__name'+this.state.highStyl}>
        { this.props.holding.security_name }
      </div>
      <div styleName='exclusions-holding__flags hidden-xs'>
        {
          this.props.issueId==='pff' ?
            <div>
              <div styleName='exclusions-holding__flag'>
                {
                  this.props.holding.is_pp ?
                    <img src={icnPp} alt='Prisons' title='Prisons'/> :
                    null
                }
              </div>
              <div styleName='exclusions-holding__flag'>
                {
                  this.props.holding.is_borders ?
                    <img src={icnBd} alt='Borders' title='Borders'/> :
                    null
                }
              </div>
            </div> :
            null
        }

        {
          this.props.issueId==='wff' ?
            <div>
              <div styleName='exclusions-holding__flag'>
                {
                  this.props.holding.is_nw ?
                    <img src={icnNw} alt='Nuclear weapons'/> :
                    null
                }
              </div>
              <div styleName='exclusions-holding__flag'>
                {
                  this.props.holding.is_cm ?
                    <img src={icnCm} alt='Controversial weapons'/> :
                    null
                }
              </div>
            </div> :
            null
        }
      </div>

      <div styleName='exclusions-holding__asset hidden-xs'>
        {
          format.money(
            this.props.holding.market_value,
            true,
            this.props.currency,
            true
          )
        }
      </div>
      <div styleName='exclusions-holding__weight hidden-xs'>
        { format.perc(this.props.holding.long_weight) }
      </div>


      <div styleName='visible-xs'>
        {
          this.props.issueId==='pff' ?
            <div>
              {
                this.props.holding.is_pp ?
                  <div styleName='exclusions-holding__flag'>
                    <img src={icnPp} alt='Prisons' title='Prisons'/>
                  </div> :
                  null
              }
              {
                this.props.holding.is_borders ?
                  <div styleName='exclusions-holding__flag'>
                    <img src={icnBd} alt='Borders' title='Borders'/> :
                  </div> :
                  null
              }
            </div> :
            null
        }

        {
          this.props.issueId==='wff' ?
            <div>
              {
                this.props.holding.is_nw ?
                  <div styleName='exclusions-holding__flag'>
                    <img src={icnNw} alt='Nuclear weapons' title='Nuclear weapons'/>
                  </div> :
                  null
              }
              {
                this.props.holding.is_cm ?
                  <div styleName='exclusions-holding__flag'>
                    <img src={icnCm} alt='Controversial weapons' title='Controversial weapons'/>
                  </div> :
                  null
              }
            </div> :
            null
        }
        <div styleName='exclusions-holding__asset'>
          {
            format.money(
              this.props.holding.market_value,
              true,
              this.props.currency,
              true
            )
          }
        </div>
        <div styleName='exclusions-holding__weight'>
          { format.perc(this.props.holding.long_weight) }
        </div>
      </div>
    </div>
  }
}


@CSSModules(Styles, {allowMultiple:true})
export default class ExclusionsHoldingList extends Component {
  static propTypes = {
    holdingLists: PropTypes.object,
    issueId: PropTypes.string
  }
  constructor(props){
    super(props)
    const holdings = props.holdingLists.holdings.slice(0,10)
    const count = props.holdingLists.holdings.length
    // const topDescription = `Top ${count} holdings by score`
    // const bottomDescription = `Bottom ${count} holdings by scores`

    const label = {
      pff: 'Prisons & borders',
      wff: 'Military weapons',
    }[this.props.issueId] || ''

    this.state = {
      showMore: false,
      issueId: (props.issueId || 'pff'),
      holdings,
      count,
      label
    }
  }
  //
  showMore = () => {
    this.setState({holdings: this.props.holdingLists.holdings})
  }
  //
  render() {
    return <div styleName='exclusions-holdings'>
      <h3 styleName='exclusions-holdings__title'>Holdings &mdash; {this.state.count} flagged holdings</h3>
      {
        this.state.holdings.map((h, i) => {
          return <ExclusionsHoldingListRow
            key={'ExclusionsHoldingListRow-'+i} idx={i+1} holding={h}
            issueId={this.props.issueId}
          />
        })
      }
      { /* show more button */ }
      {
        this.state.holdings.length < this.props.holdingLists.holdings.length ?
          <button
            onClick={this.showMore}
            styleName='exclusions-holdings__button'
          >
            Show more<LinkIcon faclass='fa-angle-double-down' />
          </button> :
          null
      }
    </div>
  }
}

